import React from "react";
import { Outlet } from "react-router-dom";
import FrontHeader from "../../shared/FrontHeader";
import FrontFooter from "../../shared/FrontFooter";
import { BannerProvider } from "../../providers/BannerProviders";
import { setTitle } from "../../helpers/MetaTag";

const FrontLayout = ({ metaTitle }) => {
  setTitle(`${metaTitle}`);
  return (
    <BannerProvider>
      <FrontHeader />
      <Outlet />
      <FrontFooter />
    </BannerProvider>
  );
};

export default FrontLayout;
